export default {
    information: {
        altSubTitle:
            'We’ll display this information on the documents you send out instead. You can change this anytime or add additional contact details later.',
        altTitle: 'Add a separate address',
        subtitle:
            'We use this information to know how to get in touch with you and for billing related processes.',
        title: "Next, let's add your business address",
    },
    pageForm: {
        title: 'Business Address',
    },
};
